import React, { Component } from 'react'
import MessageStatusView from './MessageStatusView';
import { checkTranslation, translate } from '../../../../utils/useful';


class MessageTextBoxNew extends Component {
    render() {
        let data = this.props.data
        // console.log('this.props.data', this.props.data)
        return (
            <div style={{}}>
                <div className={"d-flex chatboxDescription"} style={{ maxWidth: 350, padding: '10px 15px', display: "flex", flexDirection: 'column', alignItems: "center", justifyContent: "center" }}>
                    <p className={" " + (this.props.isOther ? 'chatbox-other-color' : 'chatbox-color')} style={{ fontSize: 14, overflowWrap: "anywhere", whiteSpace: "pre-wrap" }}>{checkTranslation(data)}</p>
                    {data.edited && (
                        <p className={"mt-1 " + (this.props.isOther ? 'chatbox-other-color' : 'chatbox-color')} style={{ fontSize: 8, textAlign: "left", width: "100%" }}>{translate('messenger.Edited')}</p>
                    )}
                </div>
                <div className={"w-100 d-flex mt-1 " + (this.props.isOther ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                    <div className="flexc">
                        <p className='mrd-2' style={{ color: "gray", fontSize: 10 }}>{checkTranslation(this.props.time)}</p>
                        {(!this.props.isOther && !this.props.hideStatus) && (
                            <MessageStatusView status={data.status} colors={this.props.colors} />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default MessageTextBoxNew;